function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext, useMemo } from 'react';
import * as Sentry from '@sentry/react';
import { getMockEventTargets } from "./event-targets/useEventTargets"; // bi log
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const logBiEvent = (id, data) => {
  const blob = new Blob([JSON.stringify(data)], {
    type: 'application/json'
  });

  try {
    navigator.sendBeacon.bind(navigator)(window._biHostname + ('/bi/' + String(id)), blob);
  } catch (ex) {
    return Sentry.withScope(scope => {
      scope.setContext('logBiEvent', {
        id
      });
      Sentry.captureException(ex);
    });
  }
};

const useInternalEventReporter = () => useContext(EventReporterContext);

export function useEventReporter() {
  const {
    gtm,
    appcues,
    heap,
    hubspot
  } = useInternalEventReporter();
  return useMemo(() => {
    const sendEvent = (category, action, label, additionalData) => {
      const eventData = _objectSpread(_objectSpread({}, additionalData), {}, {
        event_category: category,
        event_action: action,
        event_label: label
      });

      const eventName = "".concat(category, "-").concat(action, "-").concat(label);
      gtm.sendEventDeprecated(eventName, eventData);
      heap.sendEventDeprecated(eventName, eventData);
      hubspot.sendEventDeprecated(eventName, eventData);
      appcues.sendEventDeprecated(eventName, eventData);
    };

    return {
      reportToGtm: gtm.report,
      reportToHeap: heap.report,
      reportToAppcues: appcues.report,
      reportToHubspot: hubspot.report,

      resetIdentity() {
        heap.resetIdentity();
        hubspot.resetIdentity();
      },

      identify(userId, userEmail, userProperties) {
        heap.identify(userId, userEmail, userProperties);
        hubspot.identify(userId, userEmail, userProperties);
        appcues.identify(userId, userEmail, userProperties);
      },

      /** @deprecated */
      reportButtonClick(buttonName) {
        return sendEvent('button', 'click', buttonName);
      },

      /** @deprecated */
      reportOpenNotification(notificationType) {
        return sendEvent('notification', 'open', notificationType);
      },

      /** @deprecated */
      reportPopupAction(popupTitle) {
        let isOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return sendEvent('popup', isOpen ? 'open' : 'close', popupTitle);
      },

      /** @deprecated */
      prepareFormObject(field_name, value) {
        return {
          field_name,
          value
        };
      },

      /** @deprecated */
      reportPageView(url, isAccountsReceivable, vendorId) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const eventData = {
          page_url: url,
          page_title: window.document.title
        };

        if (isAccountsReceivable != undefined) {
          eventData.vendor_id = isAccountsReceivable ? vendorId : null;
          eventData.user_type = isAccountsReceivable ? 'vendor' : 'customer';
        }

        gtm.sendPageView(url, eventData);
        hubspot.sendPageView(url, eventData);
        appcues.sendPageView(url, eventData);
      },

      /** @deprecated
       * Migration example
       *
       * Before:
       * reportFormSubmission('user-successfully-sent-first-agreement', null);
       *
       * After:
       * reportToGtm('form-success', 'user-successfully-sent-first-agreement');
       * reportToAppcues('form-success', 'user-successfully-sent-first-agreement');
       * reportToHubspot('user_successfully_sent_first_agreement_');
       * reportToHeap('agreementStudio', 'submit', 'user-successfully-sent-first-agreement');
       */
      reportFormSubmission(formName, formData) {
        return sendEvent('form', 'success', formName, {
          form: formData || {}
        });
      },

      /** @deprecated */
      reportProductsFormSubmission(formName, productsArr) {
        return sendEvent('form', 'success', formName, {
          products: productsArr || []
        });
      }

    };
  }, []);
}
const EventReporterContext = /*#__PURE__*/React.createContext(getMockEventTargets());
export function EventReporterProvider(_ref) {
  let {
    children,
    eventTargets
  } = _ref;
  return /*#__PURE__*/React.createElement(EventReporterContext.Provider, {
    value: eventTargets
  }, children);
}